"use client";

import classNames from "classnames";
import React, { FC } from "react";

import Image from "@/components/ui/Image/Image";

import { ButtonSize } from "../ui/Button/Button";
import ButtonOrVideoModal from "../ui/ButtonOrVideoModal/ButtonOrVideoModal";
import { VideoCardProps } from "./types";

interface Props {
  index: number;
  card: VideoCardProps;
}
const VideoCard: FC<Props> = ({ card, index }) => {
  return (
    <li
      className={classNames("relative mb-l rounded-lg shadow-strong bg-cover bg-center flex items-end overflow-hidden md:mb-0", {
        "aspect-[2/1] md:col-span-4 md:row-span-2": index === 0,
        "aspect-[4/4]": index !== 0,
      })}
    >
      {card.image && (
        <Image
          alt={card.image.title ?? card.title}
          src={card.image.url}
          width={card.image?.width || 550}
          height={card.image?.height || 420}
          className={`transition transform hover:duration-[6000ms] group-hover:scale-105 motion-reduce:transition-none motion-reduce:hover:transform-none w-full h-full ${index === 0 ? "object-cover object-center" : "object-cover"}`}
        />
      )}

      <div className="img-overlay-2 absolute top-0 left-0 bottom-0 right-0"></div>
      <div className={`absolute bottom-0 w-full p-s`}>
        <h3 className="text-white font-secondary text-m font-medium">{card.title}</h3>
        {card.video && (
          <ButtonOrVideoModal
            btnSize={ButtonSize.SMALL}
            cta={card.video}
            btnClasses="btn btn-primary-white !border-white hover:!border-0 mt-[8px] font-medium cursor-pointer inline-block"
            modalTitle={card.video?.embeddedVideo?.label ?? card.video?.video?.title ?? ""}
            showIcon
            iconBlack
          />
        )}
      </div>
    </li>
  );
};
export default VideoCard;
